import { ChartSerie } from '@zero/shared/util-models';

export class ChartHelperUtil {
  public static cleanupAndSortChartSeries(series: ChartSerie[], isIntraday = false): ChartSerie[] {
    if (!series?.length) {
      return [];
    }

    const basicFilter = (item: ChartSerie) => Object.keys(item).length > 1 && Date.parse(item.Date);
    const filter = (item: ChartSerie) => (!isIntraday ? basicFilter(item) && item.Close && !isNaN(item.Close) : basicFilter(item));

    const filteredSeries = series
      .map((item) => {
        // Safari 15.x has some limits using dates and only accepts "ISO 8601 combined date-time format" based formats.
        // We need to enrich T as delimiter while operating with dates. Other Browsers are more resilient and accept both
        // string date formats.
        item.Date = item.Date ? item.Date.replace(' ', 'T') : item.Date;
        return item;
      })
      .filter(filter)
      .sort((a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime())
      .map((item) => {
        // We need remove T-delimiter after operating with date datatype, because lightweight-chart
        // cannot handle "ISO 8601 combined date-time" formats
        item.Date = item.Date ? item.Date.replace('T', ' ') : item.Date;
        return item;
      });

    return [...new Map(filteredSeries?.map((item) => [item['Date'], item])).values()];
  }
}
